import React, { Component } from "react";
class Background extends Component {
    render() {
        return <div className="noise" id="noise"/>;
    }
}
export default Background;
